import React from "react";
import styles from "../Services/Services.module.css";
import Service from "../../components/Service/Service";
import Contact from "../../components/Contact/Contact";
import Plans from "../../components/Plans/Plans";
import Parts from "../../components/Parts/Parts";
import Brands from "../../components/Brands/Brands";
import Why_and_Safety from "../../components/Why_and_Safety/Why_and_Safety";
import TopService from "../../components/TopService/TopService";
import Purifiers from "../../components/Purifier/Purifier";
import CustomerReview from "../../components/CustomerReview/CustomerReview";
import Faqs from "../../components/Faqs/Faqs";
import Customer_Talks from "../../components/Customer_Talks/Customer_Talks";

const Services = () => {
  return (
    <div className={styles.container}>
      <div className={styles.service}>
        {/* service near you  components */}
        <p className={styles.service_heading}>
          Water Purifier Service Near You
        </p>
        <Service />

        {/*  all plans list  components */}
        <p className={styles.plans_heading}>Browse AMC Plans</p>
        <Plans />

        {/* parts and price  component */}
        <p className={styles.parts_heading}> Spare Parts Price with Brands</p>
        <Parts />

        {/* why_and_safety  component */}
        <Why_and_Safety />

        {/* Trusted   brands      component */}
        <p className={styles.brands_heading}>Trusted Services Provider</p>
        <Brands />

        {/* TopService in Delhi ncr component */}
        <TopService />

        {/* RO Water Purifiers services  component */}
        <Purifiers />

        {/* Faqs and Answers  component */}
        <Faqs />

        {/* customers talks component */}
        <Customer_Talks />

        {/* customers review only for mobile**** component */}
        <CustomerReview />
      </div>
      <div className={styles.contact}>
        <Contact />
      </div>
    </div>
  );
};

export default Services;
